document.addEventListener("DOMContentLoaded", function (event) {
    const modalMain = new bootstrap.Modal(document.querySelector("#modalMain"));
    const modalBtns = document.getElementsByClassName("btn-modal");
    let getModalBody = modalMain._element.getElementsByClassName("modal-body").item(0);
    let getModalTt = modalMain._element.getElementsByClassName("modal-title").item(0);

    if (modalBtns.length) {
        Array.from(modalBtns).forEach((ele) => {
            ele.addEventListener("click", (e) => {
                clickModalBtn(e, ele); // or ele
            });
        });
        modalMain._element.addEventListener("shown.bs.modal", function () {
            sibmitModalForm();
        });
    }

    function clickModalBtn(e, ele) {
        e.preventDefault();
        const url = ele.href || ele.dataset.url;
        const tt = ele.title || ele.dataset.tt;
        fetch(url, {
            method: "get",
            // headers: {
            //     "Content-Type": "text/plain"
            // },
        })
            .then(function (response) {
                return response.text();
            })
            .then(function (html) {
                // var script = document.createElement("script");
                // script.setAttribute("type", "text/javascript");
                // script.setAttribute("src", "https://www.google.com/recaptcha/api.js");
                // document.head.appendChild(script);

                getModalBody.innerHTML = html;
                getModalTt.textContent = tt;
                modalMain.show();
            });
        // .catch(function (err) {
        //     console.log(err);
        // });
    }

    function sibmitModalForm() {
        const formAj = document.querySelector("#formAj");
        if (formAj) {
            let url = formAj.getAttribute("action");

            let message = new Object();
            message = {
                loading: ["Загрузка...", "info"],
                success: ["Сообщение отправлено.", "success"],
                all_error: ["Исправьте ошибки формы", "warning"],
                failure: ["Что-то пошло не так...", "danger"],
            };
            let statusMessage = document.createElement("div");
            function setMessage(el) {
                statusMessage.innerHTML = message[el][0];
                statusMessage.classList.add("status", "mb-4", "text-" + message[el][1]);
            }

            formAj.addEventListener(
                "submit",
                function (e) {
                    e.preventDefault();
                    formAj.parentNode.insertBefore(statusMessage, formAj);
                    let xhr = new XMLHttpRequest(); // создам XMLHttpRequest
                    // Это простой способ подготавливить данные для отправки (все браузеры и IE > 9)
                    let formData = new FormData(formAj); // или e1.target здесь === formAj
                    // xhr.addEventListener("error", e => {console.log('error', e); });
                    // Настройка AJAX запроса
                    xhr.open("POST", url); // инициализируем XMLHttpRequest, не открывает соединение лишь конфигурирует запрос
                    // xhr.setRequestHeader('HTTP_X_REQUESTED_WITH', 'XMLHttpRequest');
                    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest"); // Ajax header
                    xhr.setRequestHeader("X-CSRFToken", window.csrftoken);
                    xhr.responseType = "json"; // or JSON.parse(xhr.response);
                    xhr.onload = function () {
                        // происходит, когда получен какой-либо ответ, включая ответы с HTTP-ошибкой, например 404
                        let data = xhr.response;
                        document.querySelectorAll(".text-danger").forEach((e) => e.remove());
                        if (xhr.readyState < 4) {
                            // <4 =  ожидаем ответ от сервера // 4 = Ответ от сервера полностью загружен
                            setMessage("loading");
                        } else if (xhr.readyState === 4) {
                            // 200 - 299 = успешная отправка данных!
                            if (data.errors === true) {
                                setMessage("all_error");
                                for (const [k, v] of Object.entries(data.fields)) {
                                    let input = formAj.querySelector("#id_" + k);
                                    if (input) {
                                        let errItem = document.createElement("div");
                                        errItem.classList.add("text-danger", "w-100");
                                        errItem.innerHTML = v;
                                        input.parentNode.insertBefore(errItem, input.nextSibling);
                                    } else {
                                        console.warn(`Не найден элемент с id="id_${k}"!`);
                                    }
                                }
                            } else {
                                if (xhr.status === 200 && xhr.status < 300) {
                                    setMessage("success");
                                    // throw new Error(message);
                                    modalMain.hide();
                                    modalMain._element.addEventListener("hidden.bs.modal", function (e) {
                                        if (data) {
                                            let getModalDivBody = modalMain._element.getElementsByClassName("modal-body").item(0);
                                            getModalDivBody.innerHTML = "Спасибо!";
                                            // modalMain.show();
                                            data = "";
                                            window.location.reload();
                                        }
                                    });
                                } else {
                                    setMessage("failure");
                                }
                            }
                        }
                    };
                    // xhr.send(JSON.stringify(formData));
                    xhr.send(formData); // посылаем запрос
                },
                false,
            );
        }
    }
});
